<template>

  <div class="operator-selector">
      <div @click="selectOperator(operator['AND'])" class="operator-selector__operator-icon operator-selector__AND-icon operator-icon">
        <svg-icon :class="operator['AND'].icon.class" :width="operator['AND'].icon.width" :height="operator['AND'].icon.height" :icon="operator['AND'].icon.svg" ></svg-icon>
      </div>

      <div @click="selectOperator(operator['OR'])" class="operator-selector__operator-icon operator-icon">
        <svg-icon :class="operator['OR'].icon.class" :width="operator['OR'].icon.width" :height="operator['OR'].icon.height" :icon="operator['OR'].icon.svg" ></svg-icon>
      </div>

      <div @click="selectOperator(operator['NOT'])" class="operator-selector__operator-icon operator-icon">
        <svg-icon :class="operator['NOT'].icon.class" :width="operator['NOT'].icon.width" :height="operator['NOT'].icon.height" :icon="operator['NOT'].icon.svg" ></svg-icon>
      </div>
  </div>

</template>

<script>

import SvgIcon from '@/components/common/svgIcon'
import operator from '@/appComponents/workbench/targetDefinition/models/operators'

export default {
  components: {
    SvgIcon
  },
  props: {
    selectedOperator: Object
  },
  data () {
    return {
      operator: operator
    }
  },
  methods: {
    selectOperator (operator) {
      this.$emit('select', operator)
    }
  }
}

</script>


<style lang='scss'>

.operator-selector {
  display: flex;

  &__operator-icon {
    margin-left: 10px;
    cursor: pointer;
  }

  &__operator-icon:first-child {
    margin-left: 0px;
  }

  &__operator-icon:hover {
    background: color(yellow);
  }

}

</style>



// WEBPACK FOOTER //
// OperatorSelector.vue?41110f44